/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FrontendFeatures } from '../../models/frontend-features';

export interface GetFeatures$Params {
}

export function getFeatures(http: HttpClient, rootUrl: string, params?: GetFeatures$Params, context?: HttpContext): Observable<StrictHttpResponse<FrontendFeatures>> {
  const rb = new RequestBuilder(rootUrl, getFeatures.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FrontendFeatures>;
    })
  );
}

getFeatures.PATH = '/api/v1/FrontendFeatures';
